jQuery(function($) {
	var $html = $('html').removeClass('no-js');

	$html.deepLinks();
	$('form input[id^="your-name_"]').attr('autocomplete', 'chrome-off');

	if(!$.supports.touch) {
		$('select[multiple]').multiselect();
	}

	// ADD ALL YOUR CUSTOM JS THINGS AFTER THIS LINE

	// close navigation on click within for mobile devices
	$('.navigation a').on('click', function() {
		$('[for="hamburgerToggle"]').click();
	});

	var initMap = function() {
		if(typeof (google) != 'undefined') {
			$('.map').one({
				'akpc:init_map': function() {
					var $container = $(this),
						akmaps = $container.data('akmaps'),
						gmap = akmaps.gmap;

					$.each(akmaps.config.latlngs, function(index, data) {
						var icon;
						data = (typeof (data.split) == 'function') ? data.split(',') : data;

						if(data[3].length > 0) {
							icon = JSON.parse(JSON.stringify(akmaps.config.marker.icon));
							icon.url = icon.url.replace('%23000', data[3].replace('#', '%23'));
						}
						else {
							icon = {
								url: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'%3E%3Cpath d='M34 14c-1.2-1.2-3.1-1.2-4.2 0l-3.1 3.1-1.6-1.6c-.4-.4-1.1-.4-1.5 0-.4.4-.4 1.1 0 1.5l1.6 1.6-7.6 7.6c-.7.7-1.1 1.5-1.2 2.5 0 .1-.1.2-.1.3l-2.5 2.5c-.8.8-.8 2-.1 2.8.4.4.9.6 1.4.7.5 0 1-.2 1.4-.6l2.6-2.6c.1-.1.2-.1.3-.1.9-.2 1.7-.6 2.4-1.3l7.6-7.6 1.8 1.8c.2.2.5.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1.1 0-1.5l-1.8-1.8 3.1-3.1c1.3-1.2 1.3-3.1.1-4.2zM20.3 28.9c-.3.3-.8.6-1.3.6-.3.1-.7.2-1 .4.2-.3.3-.6.3-1 .1-.5.3-.9.6-1.3l7.8-7.5 1.3 1.3-7.7 7.5zm12.2-12.2l-3.1 3.1-1.3-1.3 3.1-3.1c.2-.2.4-.3.6-.3.2 0 .5.1.6.3.5.4.5 1 .1 1.3z' fill='%23132d47'/%3E%3C/svg%3E",
								scaledSize: {
									width: 48,
									height: 48
								},
								anchor: {
									x: 15,
									y: 33
								}
							};
						}
						akmaps.markers[index].setIcon(icon);
						google.maps.event.clearListeners(akmaps.markers[index], 'click');
						akmaps.markers[index].addListener('click', function() {
							var id = data[2],
								$holder = $container.parent().find('[data-details]');

							$.getJSON(fwvApiSettings.rest_root + 'wp/v2/location/' + id, function(data) {
								$holder.html('');
								$holder.removeAttr('style');
								$holder.css({
									position: 'relative',
									padding: '1.5rem',
									marginBottom: '1.5rem',
									maxHeight: '15rem',
									overflow: 'auto',
									border: '4px solid ' + (data.color || 'currentColor')
								});
								$holder.append('<strong style="color:' + (data.color || 'currentColor') + '">' + data.title.rendered + '</strong>');
								$holder.append('<p>' + data.content.rendered.replace(/\n/g, '<br>') + '</p>');
								if(data.featured_image_url) {
									$holder.append('<img src="' + data.featured_image_url + '" alt="' + data.title.rendered + '" style="width:50%;height:auto;display:inline-block">');
								}
								$holder.append('<br><br>');
								$holder.append($('<a>').attr({
									href: '#'
								}).css({
									position: 'absolute',
									top: '0.5rem',
									right: '1rem',
									fontSize: '2rem'
								}).click(function() {
									$holder.html('');
									$holder.removeAttr('style');
									return false;
								}).html('&times;'))
							});
						});
					});

					const imageBounds = {
						north: 51.98569,
						west: 10.638707,
						south: 51.010353,
						east: 13.396873
					};
					var overlay = new google.maps.GroundOverlay(
						akmaps.config.overlay,
						imageBounds,
						{
							clickable: false
						}
					);
					overlay.setMap(gmap);
					gmap.maxZoom = 9;
				}
			}).filter(function() {
				return !!$(this).data('akmaps');
			}).each(function() {
				setTimeout(function() {
					$(this).trigger('akpc:init_map')
				}.bind(this), 1000);
			});
		}
	};
	setTimeout(initMap, 1000);
});
